










































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { ActionMethod } from "vuex";

import moment from "moment";
import ReferralListComponent from "@/components/ReferralList.vue";
import DefaultPatientSearchDialog from "@/components/espoed/DefaultPatientSearchDialog.vue";
import { PagingOptions, GenericReferral, SignalREvents } from "@/types/types";
import { ReferralSearchOptions, ReferralModel } from "@/types/aznconnect_api";
import SignalRHub from "@/services/SignalRHub";

import MainToolbar from "@/views/espoed/MainToolbar.vue";
import { UserPermissions } from "@/types/store";

const DEFAULT_CLUSTER: string = "-";
const DEFAULT_DEPARTMENT: string = "-";
const DEFAULT_TYPE: string = "-";
const DEFAULT_PRIORITY: string = "-";

@Component({
  components: {
    "main-toolbar": MainToolbar,
    "referral-list": ReferralListComponent,
    "default-patient-search-dialog": DefaultPatientSearchDialog,
  },
})
export default class ListView extends Vue {
  @Prop({ default: DEFAULT_CLUSTER })
  cluster!: string;

  @Prop({ default: DEFAULT_DEPARTMENT })
  department!: string;

  @Prop({ default: DEFAULT_TYPE })
  type!: string;

  @Prop({ default: DEFAULT_PRIORITY })
  priority!: string;

  @Prop({ default: null })
  signalRHub!: SignalRHub;

  private resetAndSearch() {
    this.hasMoreData = true;
    this.searchReferrals(true);
  }

  @Watch("cluster") onClusterChanged(val: string, oldVal: string) {
    this.resetAndSearch();
  }

  @Watch("department") onDepartementChanged(val: string, oldVal: string) {
    this.resetAndSearch();
  }

  @Watch("type") onTypeChanged(val: string, oldVal: string) {
    this.resetAndSearch();
  }

  @Watch("priority") onPriorityChanged(val: string, oldVal: string) {
    this.resetAndSearch();
  }

  @Getter("userPermissions")
  userPermissions!: UserPermissions;

  @Getter("referrals", { namespace: "espoed" })
  referrals!: Array<GenericReferral>;

  showList: boolean = true;
  paging: PagingOptions = new PagingOptions(50, undefined);
  searchFilter: string = "";
  searchFromMenu: boolean = false;
  searchFrom: string = "";
  searchToMenu: boolean = false;
  searchTo: string = "";
  loading: boolean = false;
  hasMoreData: boolean = true;
  detailedReferralReference: string = "";

  isEditingPatientNumber: boolean = false;
  patientNumberReferralReference?: string = "";

  @Action("searchReferrals", { namespace: "espoed" })
  searchReferralsAction!: ActionMethod;

  @Action("resolveReferral", { namespace: "espoed" })
  resolveReferralAction!: ActionMethod;

  @Action("updateReferralOpenedState", { namespace: "espoed" })
  updateReferralOpenedState!: ActionMethod;

  private formatDate(date: string): string {
    return date ? moment(date).format("DD-MM-YYYY") : "";
  }

  get formattedSearchFrom(): string {
    return this.formatDate(this.searchFrom);
  }

  get formattedSearchTo(): string {
    return this.formatDate(this.searchTo);
  }

  openLinkPatient(referral: GenericReferral) {
    this.patientNumberReferralReference = referral.reference;
    this.isEditingPatientNumber = true;
  }

  clickedReferralResolve(referral: GenericReferral) {
    this.resolveReferralAction(referral.reference);
  }

  openDetails(referral: GenericReferral) {
    this.showList = false;
    var detailPageName = "espoed-search-detail";
    this.$router.push({
      name: detailPageName,
      params: { referralId: referral.reference || "" },
    });
  }

  clickedAmbuFeedback(referral: GenericReferral) {
    this.showList = false;
    var detailPageName = "espoed-search-detail";
    this.$router.push({
      name: detailPageName,
      params: { referralId: referral.reference || "" },
    });
  }

  openedDetails() {
    // This handler makes sure the list is hidden when details are opened
    this.showList = false;
  }

  closeDetails() {
    this.showList = true;
    this.$router.go(-1);
  }

  closedDetails() {
    // This handler makes sure the list is shown when using the browsers 'back' button
    this.showList = true;
  }

  searchReferrals(newRequest: boolean): boolean {
    const vm = this;

    if (newRequest) {
      this.paging.datetime = undefined;
      this.hasMoreData = true;
    }

    // Stop if we know there's no more data
    if (!this.hasMoreData && !newRequest) {
      return false;
    }

    this.loading = true;

    // Create a copy of the paging options to avoid cross request mixup
    let searchPagingOptions = new PagingOptions(
      this.paging.pageSize,
      this.paging.datetime,
    );

    const searchOptions: ReferralSearchOptions = new ReferralSearchOptions(
      this.cluster,
      this.department,
      this.type,
      this.priority,
      searchPagingOptions,
      this.searchFilter,
      this.formattedSearchFrom,
      this.formattedSearchTo,
    );

    this.searchReferralsAction(searchOptions)
      .then(response => {
        const newlyLoaded =
          response && response.newlyLoaded ? response.newlyLoaded : 0;

        // If no new items were added, stop loading on next scroll
        if (newlyLoaded === 0) {
          this.hasMoreData = false;
          return;
        }

        if (this.referrals) {
          const lastElement = this.referrals[this.referrals.length - 1];
          if (lastElement) {
            const etaDateTime = `${lastElement.etaDate} ${lastElement.etaTime}`;
            const etaTime = moment(etaDateTime, "DD-MM-YYYY HH:mm:ss", true);

            if (etaTime.isValid()) {
              this.paging.datetime = etaTime.format();
            } else {
              const messageDateTime = moment(lastElement.messageDateTime);
              if (messageDateTime.isValid()) {
                this.paging.datetime = messageDateTime.format();
              }
            }
          }
        }
      })
      .catch(error => {
        vm.loading = false;
        // eslint-disable-next-line no-console
        console.error("Error searching referrals");
      })
      .finally(() => {
        vm.loading = false;
      });

    return false;
  }

  beforeMount(): void {
    this.searchReferrals(true);
  }

  created(): void {
    if (this.signalRHub != null) {
      this.signalRHub.registerOnConnectedHandler(this.reconnectedHandler);
      this.signalRHub.hubProxy.on(
        SignalREvents.AddReferral,
        this.newReferralHandler,
      );
      this.signalRHub.hubProxy.on(
        SignalREvents.ReferralOpened,
        this.referralOpenedHandler,
      );
    }
  }

  beforeDestroy(): void {
    if (this.signalRHub != null) {
      this.signalRHub.unregisterOnConnectedHandler(this.reconnectedHandler);
      this.signalRHub.hubProxy.off(
        SignalREvents.AddReferral,
        this.newReferralHandler,
      );
    }
  }

  private hasSignalrConnectedOnce = false;
  reconnectedHandler() {
    // Only act on reconnects, since beforeMount takes care of the initial load
    if (this.hasSignalrConnectedOnce) {
      this.searchReferrals(true);
    } else {
      this.hasSignalrConnectedOnce = true;
    }
  }

  newReferralHandler(referral: ReferralModel) {}

  referralOpenedHandler(fieldEncounterId: string) {
    this.updateReferralOpenedState(fieldEncounterId);
  }

  getUrgencyList(): Array<string> {
    let distinctReturnList = new Array<string>();
    if (this.referrals) {
      this.referrals.forEach(referral => {
        distinctReturnList.unshift(referral.urgencyCode);
      });
    }
    return distinctReturnList.filter((v, i, a) => a.indexOf(v) === i).sort();
  }
}
